// extracted by mini-css-extract-plugin
module.exports = {"card":"CardShimmer_card__z7wsp","image":"CardShimmer_image__YOlAY"};